import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Button, Spin, Modal, Input, message } from 'antd';
import api from '../../api/axios'; 
import { AppDispatch, RootState } from '../../redux/store';
import { getAllPackagesByResellerId, sellPackage } from '../../redux/slices/packageSlice';
import { SellPackageRequest } from '../../models/SellPackageRequest';

export function PosPackageDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { packages, loading } = useSelector((state: RootState) => state.packages);

  const [selectedPackage, setSelectedPackage] = useState<any>(null);
  const [sellModalVisible, setSellModalVisible] = useState(false);
  const [buyerEmail, setBuyerEmail] = useState('');
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (!packages.length) {
      dispatch(getAllPackagesByResellerId());
    }
  }, [dispatch, packages.length]);

  useEffect(() => {
    if (packages.length && id) {
      const found = packages.find(pkg => pkg.id === Number(id));
      setSelectedPackage(found || null);
    }
  }, [packages, id]);

  const handleBack = () => {
    navigate('/');
  };

  const handleSell = () => {
    setSellModalVisible(true);
  };

  const confirmSell = async () => {
    if (!selectedPackage) return;

    setProcessing(true);
    try {
      if(selectedPackage){
      const payload: SellPackageRequest = {
        packageId: selectedPackage.prepaidPackageTemplateId,
        email: buyerEmail || null,
        phoneNumber:null,
        iccid: selectedPackage.iccid,
        cost: selectedPackage.cost
      };

      const resultAction = await dispatch(sellPackage(payload));

      if (sellPackage.fulfilled.match(resultAction)) {
        const { urlQrCode, subscriberId } = resultAction.payload;

        message.success('Package sold successfully!');
        setSellModalVisible(false);
        setBuyerEmail('');

        navigate(`/sale/qr`, { state: { esimUrl: urlQrCode,subscriberId: subscriberId, } });
      }
    }
    } catch (error) {
      message.error('Failed to sell package.');
    } finally {
      setProcessing(false);
    }
  };

  if (loading || !selectedPackage) {
    return (
      <div style={{ textAlign: 'center', marginTop: 100 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Button onClick={handleBack} style={{ marginBottom: 24 }}>
        Back
      </Button>

      <Card
        style={{ maxWidth: 500, margin: '0 auto', textAlign: 'center', padding: 24 }}
        bodyStyle={{ padding: 24 }}
      >
        <h2>{selectedPackage.prepaidPackageTemplateName}</h2>
        <p style={{ fontSize: 18, marginBottom: 12 }}>
          <strong>{(selectedPackage.dataByte / (1024 * 1024)).toFixed(0)} MB</strong>
        </p>
        <p style={{ marginBottom: 8 }}>{selectedPackage.periodDays} Days</p>
        <p style={{ fontSize: 24, fontWeight: 'bold', color: '#1890ff', marginBottom: 24 }}>
          {selectedPackage.cost}€
        </p>

        <Button type="primary" size="large" onClick={handleSell}>
          Sell Package
        </Button>
      </Card>

      {/* Sell Modal */}
      <Modal
        title="Sell Package"
        open={sellModalVisible}
        onCancel={() => setSellModalVisible(false)}
        onOk={confirmSell}
        okText="Confirm Sale"
        confirmLoading={processing}
      >
        <p>Enter buyer's email (optional):</p>
        <Input
          placeholder="Email address"
          value={buyerEmail}
          onChange={(e) => setBuyerEmail(e.target.value)}
        />
      </Modal>
    </div>
  );
}

export default PosPackageDetail;


